<li class="nav-item">
    <button class="btn btn-success text-white me-2" (click)="recoverFinished()"><i class="fa fa-recycle" aria-hidden="true"></i> {{ "recoverFinished" | language }}</button>
</li>
